var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.snippet)?_c('text',{staticStyle:{"white-space":"pre"},attrs:{"fill":"currentColor"},domProps:{"textContent":_vm._s(_vm.snippet)}}):_c('text',{staticStyle:{"font-size":"6px"},attrs:{"fill":"currentColor"}},[_vm._v("⮐")])}
var staticRenderFns = []

export { render, staticRenderFns }